import { CPAEventParams } from 'src/app';

export const pushCPAConversion = (params: CPAEventParams): void => {
    if (window.iapSDK !== undefined) {
        window.iapSDK.push(params);
    }
};
